import { render, staticRenderFns } from "./MenuTabConfig.vue?vue&type=template&id=541a5a14&"
import script from "./MenuTabConfig.vue?vue&type=script&lang=js&"
export * from "./MenuTabConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports